// extracted by mini-css-extract-plugin
export var actions = "_2-0";
export var actionsContainer = "_2-7";
export var border = "_2-1";
export var childFullHeight = "_2-g";
export var collapse = "_2-2";
export var content = "_2-b";
export var contentChild = "_2-f";
export var fullscreen = "_2-d";
export var hasLeftRadius = "_2-l";
export var headerContainer = "_2-3";
export var headerRow = "_2-5";
export var hidePadding = "_2-c";
export var navCollapsedGap = "_2-m";
export var noScrollX = "_2-n";
export var noScrollY = "_2-o";
export var noTopPadding = "_2-j";
export var optOutTopPadding = "_2-e";
export var pageMain = "_2-k";
export var pageOuter = "_2-h";
export var pagePadding = "_2-8";
export var pageScroll = "_2-9";
export var profile = "_2-p";
export var profileContainer = "_2-q";
export var profileImage = "_2-r";
export var profileMain = "_2-s";
export var profileSubtitle = "_2-u";
export var profileTitle = "_2-t";
export var settingsSurface = "_2-a";
export var showLeftPadding = "_2-i";
export var tabsPortalSlot = "_2-6";
export var tabsWrapper = "_2-4";
export var title = "_2-v";